module.exports = require("@babel/runtime/helpers/inherits");;